import { X } from 'lucide-react';
import React from 'react';

import { Button } from '@/components/ui/button';

import { CaseIngestionAssistPanel } from './CaseIngestionAssistPanel';
import type { CaseIngestionAssistState } from './types';

interface AssistSidebarPanelProps {
  assistState: CaseIngestionAssistState;
  isOpen: boolean;
  onClose: () => void;
  currentStepId?: string;
}

export const AssistSidebarPanel: React.FC<AssistSidebarPanelProps> = ({
  assistState,
  isOpen,
  onClose,
  currentStepId,
}) => {
  if (!assistState.hasImport || !isOpen) return null;

  return (
    <aside className="w-80 flex-shrink-0 border-l border-zinc-200 dark:border-zinc-700 overflow-y-auto bg-white dark:bg-zinc-900">
      {/* Header */}
      <div className="flex items-center justify-between border-b border-zinc-100 px-4 py-3 dark:border-zinc-800">
        <h2 className="text-xs font-semibold text-zinc-800 dark:text-zinc-200">
          CMS Assist
        </h2>
        <Button
          variant="ghost"
          size="sm"
          onClick={onClose}
          className="h-6 w-6 p-0 text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-300"
        >
          <X className="h-3.5 w-3.5" />
        </Button>
      </div>

      {/* Panel body */}
      <div className="px-4 py-3">
        <CaseIngestionAssistPanel assistState={assistState} currentStepId={currentStepId} />
      </div>
    </aside>
  );
};
